<template>
  <div class="hasAgentDeatil">
    <el-dialog :title="$t('other.a2462')" :visible.sync="dialogVisible" width="30%">
      <div class="waterWrapper">
        <div :class="{ 'waterProduct': true, 'active': imgUrl == item.watermarkUrl }" @click="imgUrl = item.watermarkUrl"
          v-for="(item, index) in imgList" :key="index">
          <img :src="item.watermarkUrl" />
          <div class="dexlet" @click="deleteWaterImg(item, index)">x</div>
        </div>
        <div>
          <el-upload action="" class="uploaImg" :http-request="uploaWaterImg" :show-file-list="false">
            <i class="el-icon-plus"></i>
          </el-upload>
        </div>
      </div>
      <div v-if="imageLength" class="okting">
        <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage"></el-progress>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="warning">{{ $t('other.a5') }}</el-button>
        <el-button type="primary" @click="addWaterImg(0)">{{ $t('other.a1431') }}</el-button>
        <el-button type="primary" @click="addWaterImg(1)">{{ $t('other.a1432') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="$t('other.a2463')" :visible.sync="updatPic" width="50%">
      <div class="ppomu">
        <div style="text-align:center">
          <div class="imgBBox"><img :src="attrImg" /></div>
          <div style="margin-top:20px;">
            <el-button size="medium" type="primary" @click="downloadImage(attrImg)">{{ $t('other.a2824') }}</el-button>

          </div>

        </div>

        <div style="text-align:center">
          <el-upload class="avatar-uploader" action="https://erp.shopsbu.com/service/access/upload"
            :show-file-list="false" :headers="token" :on-success="handleAvatarSuccess">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div style="margin-top:20px;"><el-button size="medium" type="info">{{ $t('other.a2825') }}</el-button></div>
          </el-upload>


        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updatPic = false">{{ $t('other.a106') }}</el-button>
        <el-button type="primary" @click="imgConfirm()">{{ $t('other.a279') }}</el-button>
      </span>
    </el-dialog>



    <!-- <div class="descTitle">
      <div class="tti">
        <el-button v-show="!isEditor" type="primary" @click="isEditor=true">{{$t('other.a238')}}</el-button>
        <el-button v-show="isEditor" type="danger" @click="updataProductInfo()">{{$t('other.a239')}}</el-button>
        <el-button v-show="isEditor" type="info" @click="isEditor=false">{{$t('other.a106')}}</el-button>
        <el-button type="primary" @click="backTo()">{{$t('other.a1279')}}</el-button>
      </div>
    </div> -->
    <!-- <div class="itemWrapper">
      <div class="itemDesc">
        <span class="olnklig">{{$t('other.a2468')}}：</span>
        <span>{{tableList.categoryName ? tableList.categoryName : $t('other.a354')}}</span>
      </div>
      <div class="itemDesc">
        <span class="olnklig">{{$t('other.a179')}}：</span>
        <div v-show="!isEditor" class="ibkg">{{tableList.name}}</div>
        <el-input v-show="isEditor" style="width:90%" v-model="tableList.name"></el-input>
      </div>
      <div class="itemDesc">
        <span class="olnklig">{{$t('other.a1390')}}：</span>
        <el-input
        style="width:90%"
          type="textarea"
          :rows="10"
          :placeholder="$t('other.a319')"
          v-model="tableList.description">
        </el-input>
      </div>
    </div> -->





    <div class="skuWrapper">

      <div class="tti">
        <el-button size="mini" v-show="!isEditor" type="primary" @click="isEditor = true">{{ $t('other.a238')
        }}</el-button>
        <el-button size="mini" v-show="isEditor" type="danger" @click="updataProductInfo()">{{ $t('other.a239')
        }}</el-button>
        <el-button size="mini" v-show="isEditor" type="info" @click="isEditor = false">{{ $t('other.a106') }}</el-button>
        <!-- <el-button size="mini" type="primary" @click="backTo()">{{$t('other.a1279')}}</el-button> -->
      </div>

      <div class="itemDesc">
        <span>{{ $t('other.a2473') }}：</span>
        <!-- <el-switch
          style="display: block"
          v-model="radio"
          @change="setProDuct()"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="以固定毛利率上架分销"
          inactive-text="以固定供货价上架分销">
        </el-switch> -->

        <div v-show="!isEditor">
          <el-radio-group v-model="radio3">
            <el-radio :label="1">{{ methodsSupplyPrice ? $t('other.a2475') : $t('other.a2474') }}</el-radio>
          </el-radio-group>
        </div>
        <div v-show="isEditor">
          <el-radio-group v-model="radio2" @change="setProDuctCopy()">
            <el-radio :label="1">{{ $t('other.a2474') }}</el-radio>
            <el-radio :label="2">{{ $t('other.a2475') }}</el-radio>
            <el-radio :label="3">{{ $t('other.a2476') }}</el-radio>
            <!-- <el-radio :label="4">清仓上架分销</el-radio> -->
          </el-radio-group>
        </div>
        <el-button style="margin-left:30px" v-show="radio2 == '3' && hasGetRate" size="mini" type="primary"
          @click="hasGetRate = false, fixedRate = true">{{ $t('other.a2477') }}</el-button>
        <span style="margin-left:30px;font-size:16px;color:red" v-show="radio2 == '3' && !hasGetRate">
          {{ $t('other.a2478') }}：{{ $t('other.a2479') }}={{ $t('other.a2137') }}+{{ $t('other.a2137') }}*
          <el-input v-show="fixedRate" size="mini" style="width:80px" v-model="rate"
            :placeholder="$t('other.a301')"></el-input>
          <span v-show="!fixedRate">{{ rate }}%</span>
          ({{ $t('other.a301') }})
        </span>
        <span style="margin-left:30px" v-show="radio2 == '3' && !hasGetRate">
          <el-button v-show="!fixedRate" size="mini" type="primary" @click="fixedRate = true">{{ $t('other.a93')
          }}</el-button>
          <el-button v-show="!fixedRate" size="mini" type="primary" @click="deleteCharge()">{{ $t('other.a312')
          }}</el-button>
          <el-button v-show="fixedRate" size="mini" type="primary" @click="updataPriceBycost()">{{ $t('other.a38')
          }}</el-button>
          <el-button v-show="fixedRate" size="mini" type="danger" @click="fixedRate = false">{{ $t('other.a146')
          }}</el-button>
        </span>
      </div>

      <el-table :data="tableList.variations" style="width: 100%" size="mini"
        :header-cell-style="{ background: '#e8e8e8', color: '#000' }" :key="itemKey" border>
        <el-table-column prop="outTradeNo" fixed :label="$t('other.a217')" width="80">
          <template slot-scope="props">
            <img @click="changePic(props.row, props.$index)" v-if="props.row.image" class="picBox" slot="reference"
              :src="props.row.image" style="width: 50px; height: 50px" />
            <span class="addImg" @click="changePic(props.row, $index)" v-else>+</span>
          </template>
        </el-table-column>

        <el-table-column label="sku" fixed>
          <template slot-scope="props">
            <span v-show="!isEditor"> {{ props.row.variationSku }}</span>
            <el-input v-show="isEditor" style="width:80px;margin-left:10px" size="mini"
              v-model="props.row.variationSku"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="cusCode" fixed>
          <template slot-scope="props">
            <div>{{ props.row.cusCode }}</div>
          </template>
        </el-table-column>
        <el-table-column v-if="radio2 == '3'" :label="$t('other.a219')">
          <template slot-scope="scope" slot="header">
            <span style="padding-right:25px">{{ $t('other.a2479') }}
              <el-tooltip class="item" effect="dark" :content="$t('other.a2480')" placement="top-start">
                <i class="el-icon-question oook"></i>:
              </el-tooltip>
              ￥</span>
            <el-input size="mini" style="width:120px" @blur="setPrice(4)" v-model="costValue"
              :placeholder="$t('other.a307')"></el-input>
          </template>
          <template slot-scope="props">
            <span>
              ￥
              <span v-show="!isEditor">{{ props.row.costCopy }}</span>
              <el-input v-show="isEditor" style="width:150px;margin-left:10px" size="mini" v-model="props.row.costCopy"
                :placeholder="props.row.costDesc"></el-input>
            </span>
          </template>
        </el-table-column>

        <el-table-column v-if="radio2 == '1'" :label="$t('other.a219')">
          <template slot-scope="scope" slot="header">
            <span style="padding-right:25px">{{ $t('other.a2479') }}
              <el-tooltip class="item" effect="dark" :content="$t('other.a2480')" placement="top-start">
                <i class="el-icon-question oook"></i>:
              </el-tooltip>
              ￥</span>

            <el-input v-show="isEditor" size="mini" style="width:120px" @blur="setPrice(1)" v-model="priceValue"
              :placeholder="$t('other.a307')"></el-input>
          </template>
          <template slot-scope="props">
            <span>￥
              <span v-show="!isEditor">{{ props.row.price }}</span>
              <el-input v-show="isEditor" style="width:80px;margin-left:10px" size="mini" v-model="props.row.price"
                :placeholder="$t('other.a2608')"></el-input>
            </span>
          </template>
        </el-table-column>

        <el-table-column v-if="radio2 == '2' || radio2 == '4'" :label="$t('other.a301')">
          <template slot-scope="scope" slot="header">
            <span style="padding-right:25px">{{ $t('other.a301') }}%({{ $t('other.a2481') }})</span>
            <el-input size="mini" style="width:120px" @blur="setPrice(2)" v-model="fixGrossProfitRate"
              :placeholder="$t('other.a307')"></el-input>

          </template>
          <template slot-scope="props">
            <span>{{ props.row.fixGrossProfitRate }}%</span>
          </template>
        </el-table-column>

        <el-table-column v-if="radio2 == '2' || radio2 == '4'" :label="$t('other.a219')">
          <template slot-scope="scope" slot="header">
            <span style="padding-right:25px">{{ $t('other.a2479') }}
              <el-tooltip class="item" effect="dark" :content="$t('other.a2480')" placement="top-start">
                <i class="el-icon-question oook"></i>:
              </el-tooltip>
              ￥</span>

          </template>
          <template slot-scope="props">
            <span>￥{{ props.row.price }}
            </span>
          </template>
        </el-table-column>



        <el-table-column :label="$t('other.a2483')">
          <template slot-scope="scope" slot="header">
            <span style="padding-right:25px">{{ $t('other.a2482') }} </span>

          </template>
          <template slot-scope="props">
            <span>￥{{ Paid(props.row.price) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a2484')">
          <template slot-scope="props">
            <span>{{ props.row.stock }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('other.a2137')">
          <template slot-scope="props">
            <span>{{ props.row.cost }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('other.a220')">
          <template slot-scope="scope" slot="header">
            <span style="padding-right:25px">{{ $t('other.a1464') }}
              <el-tooltip class="item" effect="dark" :content="$t('other.a2485')" placement="top-start">
                <i class="el-icon-question oook"></i>:
              </el-tooltip>
              ￥</span>
            <el-input v-show="isEditor" size="mini" style="width:120px" @blur="setPrice(3)" v-model="wholesalePrice"
              :placeholder="$t('other.a307')"></el-input>
          </template>
          <template slot-scope="props">
            <span>￥

              <span v-show="!isEditor">{{ props.row.wholesalePrice }}</span>
              <el-input v-show="isEditor" style="width:80px;margin-left:10px" size="mini"
                v-model="props.row.wholesalePrice"></el-input>
            </span>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope" slot="header">
            <span style="padding-right:25px">{{ $t('other.a2826') }}
              <el-tooltip class="item" effect="dark" :content="$t('other.a2486')" placement="top-start">
                <i class="el-icon-question oook"></i>:
              </el-tooltip>
            </span>
          </template>
          <template slot-scope="props">
            <span>{{ props.row.proportion ? $t('other.a191') : $t('other.a192') }}</span>
          </template>
        </el-table-column>



        <el-table-column :label="$t('other.a2488')">
          <template slot-scope="props">
            <div><span style="margin-right:10px">{{ getCur(props.row.country) }}</span>{{ props.row.priceList }}</div>
            <div><span style="margin-right:10px">RMB</span>{{ props.row.minRmb }}</div>
          </template>
        </el-table-column>

      </el-table>

    </div>

    <div class="itemImage">

      <div class="itemDesc" style="justify-content:start;" v-if="false">
        <span class="olnklig">{{ $t('other.a2468') }}：</span>
        <!-- <span>{{tableList.categoryName ? tableList.categoryName : $t('other.a354')}}</span> -->
        <el-select size="mini" v-model="tableList.categoryName" placeholder="" :disabled="isEditor ? false : 'disabled'">
          <el-option v-for="item in categoryArr" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </div>
      <div class="itemDesc">
        <div style="display:flex">
          <div>{{ $t('other.a2469') }}</div>

          <el-upload class="obikg" v-show="isEditor" action="" multiple :http-request="handleUploadHttpRequest"
            :show-file-list="false">
            <el-button id="initSlide" size="mini" type="primary">{{ $t('other.a2470') }}</el-button>
          </el-upload>
          <div v-show="isEditor"><el-button class="obikg" type="primary" size="mini" @click="randomNum()">{{
            $t('other.a2471') }}</el-button></div>
          <div v-show="isEditor" class="obikg"><el-button size="mini" type="primary" @click="getWaterImg()">{{
            $t('other.a291') }}</el-button></div>
        </div>

      </div>

      <div>
        <div class="okjnvk">
          <draggable class="oknolg" v-model="tableList.images" tag='ul' v-bind="dragOptions"
            @start="tableList.drag = true" @end="tableList.drag = false">

            <span @mouseenter="active = imgUrl.positions" @mouseleave="active = -1"
              v-for="(imgUrl, index) in tableList.images" :key="index">
              <div class="kgnlv" ref="kgnlv">
                <img v-if="imgUrl.image" class="onkg" :src="imgUrl.image">
                <span v-if="imgUrl.image && active == imgUrl.positions && isEditor" class="deleteImg"
                  @click="deleteImg(index)">{{ $t('other.a273') }}</span>
                <span v-if="!imgUrl.image" class="ytjg">
                  <div style="text-align:center;font-size:20px">+</div>
                  <div>{{ $t('other.a2472') }}</div>
                </span>
                <img v-if="index == imgNum" class="onkg" :src="imgUrlCopy">
              </div>
              <div class="iklng">{{ $t('other.a657') }}{{ index + 1 }}</div>

            </span>
          </draggable>
        </div>
      </div>
    </div>

    <div class="skuWrapper">
      <div class="itemDesc">{{ $t('other.a2489') }}：</div>
      <div class="okng">
        <span class="ttpoi">{{ $t('other.a2827') }}：</span>
        <span v-show="!isEditor">{{ tableList.packageHeight }}</span>
        <el-input v-show="isEditor" class="inputBox" size="medium" type="text" v-model="tableList.packageHeight"
          :placeholder="$t('other.a1255')"></el-input> x
        <span v-show="!isEditor">{{ tableList.packageLength }}</span>
        <el-input v-show="isEditor" class="inputBox" size="medium" type="text" v-model="tableList.packageLength"
          :placeholder="$t('other.a1256')"></el-input> x
        <span v-show="!isEditor">{{ tableList.packageWidth }}</span>
        <el-input v-show="isEditor" class="inputBox" size="medium" type="text" v-model="tableList.packageWidth"
          :placeholder="$t('other.a1257')"></el-input> cm
      </div>
      <div class="okng">
        <span class="ttpoi">{{ $t('other.a1253') }}：</span>
        <span v-show="!isEditor">{{ tableList.weight }}</span>
        <el-input v-show="isEditor" class="inputBox" size="medium" type="text" v-model="tableList.weight"
          :placeholder="$t('other.a1516')"></el-input> kg
      </div>

    </div>

    <div class="skuWrapper">
      <div class="itemDesc">{{ $t('other.a1390') }}：</div>
      <el-input type="textarea" :disabled="!isEditor" placeholder="" autosize v-model="tableList.description" />
    </div>

  </div>
</template>

<script>

import { mapState, mapActions, mapMutations } from "vuex";
import draggable from "vuedraggable"
import utils from '../../../utils/utils'
import api from '../../../api/api'
import userStoreItemsApi from '../../../api/moudles/userStoreItems'
import dialogPlugin from '@/pages/stockProduct/component/diaload'
import QrcodeDialog from '../../../components/dialog/qrcodeDialog.vue'
import jsonp from '../../../api/jsonp';
import mygoods from '../../../api/moudles/mygoods';
import neworderApi from '../../../api/moudles/newOrders'
import distributionApi from '../../../api/moudles/distribution'
import md5 from 'js-md5'
import html2canvas from 'html2canvas'

export default {
  data() {
    return {
      productModel: {},
      originArray: {},
      isEditor: false,
      changePicObj: {},
      wholesalePrice: null,
      originItem: null,
      onlineItem: null,
      imageUrl: '',
      itemKey: 0,
      attrImg: null,
      rate: null,
      methodsSupplyPrice: null,
      fixedRate: false,
      updatPic: false,
      hasGetRate: true,
      radio: "1",
      radio2: 1,
      radio3: 1,
      percentage: 0,
      imageLength: 0,
      dialogVisible: false,
      active: -1,
      userId: null,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      variations: [],
      tableList: [],
      variationId: null,
      calcNum: 0,
      materialUrl: null,
      priceValue: null,
      costValue: null,
      imgNum: 0,
      fixGrossProfitRate: null,
      token: {
        token: JSON.parse(localStorage.getItem('userInfo')).token
      },
      imgList: [
        '',
        'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/6e01a45243154306959f5fae1c99b37b.jpg',
        'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/a704a09903c847f9a491b6604dda376b.jpg',
        'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/9d2c717cef94441e90f856de046c6a72.jpg'
      ],
      imgUrl: null,
      imgUrlCopy: null,
      categoryArr: ['家居用品', '厨具', '纺织品和软家具', '家用电器', '女装和内衣', '穆斯林时尚', '鞋', '美容和个人护理', '电话和电子产品', '计算机和办公设备', '宠物用品', '婴儿和产妇', '运动和户外', '玩具和爱好', '家具', '工具和硬件', '家庭改善', '汽车和摩托车', '时尚配饰', '食品和饮料', '健康', '儿童时装', '男装和内衣', '行李和箱包', '收藏', '珠宝配件和衍生品']
    }
  },
  components: {
    draggable
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },
  },
  watch: {
    calcNum() {
      this.percentage = Math.round(this.calcNum / this.imageLength * 100)
    },
    dialogVisible() {
      if (!this.dialogVisible) {
        this.imgUrl = null
      }
    },
    radio() {
      if (this.radio) {
        console.log('jkmn')
        this.fixGrossProfitRate = 5
        this.setPrice(2)
      } else {
        this.originItem.fixGrossProfitRate = null
      }
      console.log(this.originItem)
    },
    updatPic() {
      if (!this.updatPic) {
        this.imageUrl = null
      }
    }
  },
  created() {
    //获取该产品所有子sku绑定的线上产品
    // this.getGroupById()
    this.userId = this.userInfo ? this.userInfo.userId : null
    this.getData()
  },
  methods: {

    downloadImage(val) {
      let _this = this
      // val 为传入的图片地址
      let _type_index = val.lastIndexOf('.');
      let _type = val.substr(_type_index + 1); //原始图片类型
      let image = new Image();
      image.setAttribute('crossOrigin', 'anonymous'); //消除跨域
      image.src = val;
      image.onload = function () {
        //借助canvas实现 消除 图片地址会先直接窗口打开图片地址
        let canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL('image/' + _type);
        let blob = _this.dataUrlToBold(url);
        let obj_url = URL.createObjectURL(blob); // 消除Chrome下文件太大 导致下载失败（网络失败）的问题
        let a = document.createElement('a');
        let event = new MouseEvent('click');
        a.download = name || 'xi-yuan';
        a.href = obj_url;
        a.dispatchEvent(event);
        loading.close();
      };
    },
    dataUrlToBold(url) {
      let arr = url.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bStr = atob(arr[1]),
        n = bStr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bStr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    deleteItem(item, index) {
      this.tableList.variations.splice(index, 1)
      this.tableList.tiers[0].optionArray.splice(index, 1)
      this.tableList.tiers[0].options = JSON.stringify(this.tableList.tiers[0].optionArray)
      let ttp = this.originItem.storeItems.findIndex(p => p.cusCode == item.cusCode)
      console.log(ttp)
      this.originItem.storeItems.splice(ttp, 1)


      console.log('item', item)
      console.log('originItem', this.originItem)
    },

    getCur(code) {
      return utils.getCurrency(code)
    },

    setProDuctCopy() {
      console.log('radio2', this.radio2)
      this.tableList.variations.forEach(p => {
        p.price = p.originPrice
      })
      if (this.radio2 == '1') {
        this.$confirm(this.$t('other.a2490'), this.$t("other.a142"), {
          confirmButtonText: this.$t("other.a884"),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
        }).then(() => {

        })
      } else if (this.radio2 == '2') {
        this.$confirm(this.$t('other.a2491'), this.$t("other.a142"), {
          confirmButtonText: this.$t("other.a884"),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
        }).then(() => {

        })
      } else if (this.radio2 == '3') {
        this.getCache()
        this.$confirm(this.$t('other.a2492'), this.$t("other.a142"), {
          confirmButtonText: this.$t("other.a884"),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
        }).then(() => {

        })
      } else if (this.radio2 == '4') {
        this.$confirm(this.$t('other.a2609'), this.$t("other.a142"), {
          confirmButtonText: this.$t("other.a884"),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
        }).then(() => {

        })
      }

      console.log(this.tableList)
      this.itemKey++

    },

    setProDuct() {
      this.itemKey++
      this.radio = !this.radio
      if (this.radio) {
        this.$confirm(this.$t('other.a2493'), this.$t("other.a142"), {
          confirmButtonText: this.$t('other.a235'),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
        }).then(() => {
          this.radio = !this.radio
        })
      } else {
        this.$confirm(this.$t('other.a2491'), this.$t("other.a142"), {
          confirmButtonText: this.$t('other.a235'),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
        }).then(() => {
          this.radio = !this.radio
        })
      }

    },

    handleAvatarSuccess(res, file) {
      console.log(res, file)
      this.imageUrl = res.data
      console.log('imageUrl', this.imageUrl)
    },

    imgConfirm() {
      let that = this
      console.log(this.changePicObj)

      if (!this.imageUrl) {
        this.$message.warning(this.$t('other.a2828'))
        return
      }
      that.tableList.variations.forEach((k, index) => {
        if (index == that.changePicObj.type) {
          k.image = that.imageUrl
        }
        this.$set(this.tableList.variations, index, k)
      })
      that.tableList.tiers[0].images[that.changePicObj.tierIndex[0]] = that.imageUrl
      let list = that.tableList.tiers[0].images.map(p => { return p })
      that.tableList.tiers[0].imagesUrl = JSON.stringify(list)



      this.updatPic = false
      this.imageUrl = null

      console.log('tableList', this.tableList)
    },

    uploaWaterImg(params) {

      console.log(params)
      const _file = params.file
      const isLt2M = _file.size / 1024 / 1024 < 2

      let formData = new FormData()
      formData.append('file', _file)



      console.log('formData', formData)

      api
        .uploadImg(formData)
        .then(res => {
          if (res.code === 200) {
            console.log(res.data)
            this.imgList.push({
              watermarkUrl: res.data,
              userId: this.userId
            })
            api
              .uploadWaterImg({
                watermarkUrl: res.data,
                userId: this.userId,
                isUsed: true
              })
              .then(res => {
                if (res.code === 200) {
                  console.log('水印上传成功', res.data)

                } else {
                  this.$message.warning(res.msg)
                }
              })

          } else {
            this.$message.warning(res.msg)
          }
        })
    },

    changePic(item, index) {
      if (!this.isEditor) {
        this.$message.warning(this.$t('other.a2829'))
        return
      }
      this.attrImg = item.image
      this.updatPic = true
      this.changePicObj = JSON.parse(JSON.stringify(item))
      this.changePicObj.type = index

      console.log('changePicObj', this.changePicObj)


    },

    deleteWaterImg(item, index) {
      this.$confirm(this.$t('other.a564'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => {
        api
          .deleteWaterImg({
            userId: this.userId,
            watermarkIds: [item.id]
          })
          .then(res => {
            if (res.code === 200) {
              console.log('desc', res.data)
              this.$message.success(this.$t('other.a565'))
              this.imgList.splice(index, 1)
            } else {
              this.$message.warning(res.msg)
            }
          })
      })
    },
    addWaterImg(num) {
      this.calcNum = 0
      if (num == 1) {//应用首图
        this.imageLength = 1
        this.getWaterPiuture(this.tableList.images[0].image, this.imgUrl, 0)
      } else if (num == 0) {//应用全部
        this.imageLength = this.tableList.images.length
        this.tableList.images.forEach((p, index) => {
          if (p.image) {
            this.getWaterPiuture(p.image, this.imgUrl, index)
          }
        })
      }
    },



    getWaterPiuture(originImg, waterImg, index) {
      console.log(originImg, waterImg)
      return new Promise((resolve) => {
        let that = this
        var canvas = document.createElement("canvas");
        canvas.width = 800
        canvas.height = 800
        let ctx = canvas.getContext('2d')
        let homeImg = originImg
        let picImg = new Image()
        picImg.setAttribute('crossOrigin', 'anonymous');
        picImg.src = homeImg

        picImg.onload = function () {
          ctx.drawImage(picImg, 0, 0, 800, 800);
          let base64 = canvas.toDataURL('image/png')
          let image = new Image()
          image.src = waterImg
          image.setAttribute('crossOrigin', 'anonymous');
          image.onload = function () {
            ctx.drawImage(image, 0, 0, 800, 800);
            let base64 = canvas.toDataURL('image/png')
            var blob = that.dataURItoBlob(base64); // 上一步中的函数
            var canvasOne = document.createElement('canvas')
            var dataURL = canvasOne.toDataURL('image/jpeg', 0.5)
            var fd = new FormData(document.forms[0]);
            fd.append("file", blob, 'image.png');
            fd.append('shopId', JSON.parse(localStorage.getItem('userInfo')).shopeeShops[0].shopId)
            fd.append('isUploadToShopee', true)
            api
              .uploadImg(fd)
              .then(res => {
                if (res.code == 200) {
                  resolve(res.data)
                  that.tableList.images[index].image = res.data.image_info_list[0].image_info.image_url_list[0].image_url
                  that.tableList.images[index].imageId = res.data.image_info_list[0].image_info.image_id
                  that.calcNum += 1
                  console.log('calcNum', that.calcNum)
                  // that.dialogVisible=false
                } else {
                  that.$message.warning(res.msg)
                }
              })
          }
        }


      })

    },

    dataURItoBlob(base64Data) {
      var byteString;
      if (base64Data.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(base64Data.split(',')[1]);
      else
        byteString = unescape(base64Data.split(',')[1]);
      var mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },

    getWaterImg(params) {

      api
        .getWaterImg({
          userId: this.userId
        })
        .then(res => {
          if (res.code === 200) {
            console.log('desc', res.data)
            this.dialogVisible = true
            this.imgList = res.data
          } else {
            this.$message.warning(res.msg)
          }
        })
    },

    deleteImg(index) {
      this.tableList.images.splice(index, 1)
      for (var i = 0, len = this.tableList.images.length; i < len; i++) {

        this.tableList.images[i].positions = i;
        this.tableList.images[i].label = "image" + i;

      }
      console.log(this.tableList.images)
    },

    randomNum() {
      let arr = JSON.parse(JSON.stringify(this.tableList.images))
      for (var i = 0, len = arr.length; i < len; i++) {
        var a = parseInt(Math.random() * len);
        var temp = arr[a];
        arr[a] = arr[i];
        arr[i] = temp;
      }

      for (var i = 0, len = arr.length; i < len; i++) {
        arr[i].positions = i;
        arr[i].label = "image" + i;
      }

      this.tableList.images = arr
      console.log('arr', arr)
    },

    getCache() {
      let ttp = null
      utils.getInfoByCache({
        cacheKey: 'C_rate',
        userId: this.userId,
      }).then(res => {
        if (res !== null) {
          this.hasGetRate = false
          this.rate = res

          this.tableList.variations.forEach(p => {
            p.price = ((100 + Number(this.rate)) / 100 * p.cost).toFixed(2)
            p.costCopy = ((100 + Number(this.rate)) / 100 * p.cost).toFixed(2)
          })

          console.log('this.', this.tableList)
        } else {
          this.hasGetRate = true
          this.rate = 5
        }
        console.log(this.rate)


      })
    },

    updataPriceBycost() {

      this.fixedRate = false
      utils.updateInfoByCache({
        cacheKey: 'C_rate',
        userId: this.userId,
        cacheData: JSON.stringify(this.rate)
      }).then(res => {
        this.getCache()

      })

    },

    deleteCharge() {
      this.tableList.variations.forEach(p => {
        p.costCopy = null
        p.price = 0
      })
      utils.updateInfoByCache({
        cacheKey: 'C_rate',
        userId: this.userId,
        cacheData: null,
      }).then(res => {
        this.de
        // this.getCache()

      })
      this.hasGetRate = true
    },


    handleUploadHttpRequest(params) {
      if (this.tableList.images.length > 9) {
        this.$message.warning(this.$t('other.a2494'))
        return
      }
      if (params.file.size > (1048576 * 15)) {
        this.$message.error('产品主图不能超过15M！');
        return
      }
      console.log(params)
      const _file = params.file
      let formData = new FormData()
      formData.append('file', _file)
      if (JSON.parse(localStorage.getItem('userInfo')).shopeeShops) {
        formData.append('shopId', JSON.parse(localStorage.getItem('userInfo')).shopeeShops[0].shopId)
        formData.append('isUploadToShopee', true)
      }

      api
        .uploadImg(formData)
        .then(res => {
          if (res.code === 200) {
            console.log(res.data)
            if (JSON.parse(localStorage.getItem('userInfo')).shopeeShops) {
              let num = this.tableList.images.length
              this.tableList.images.push({
                image: res.data.image_info_list[0].image_info.image_url_list[0].image_url,
                imageId: res.data.image_info_list[0].image_info.image_id,
                positions: num,
                label: 'image' + num
              })
            }else{
              let num = this.tableList.images.length
              this.tableList.images.push({
                image: res.data,
                imageId: null,
                positions: num,
                label: 'image' + num
              })
            }
          } else {
            this.$message.warning(res.msg)
          }
        })
    },

    getGroupById() {
      api
        .getStoreItemByGroupId({
          groupId: this.$route.query.groupId
        })
        .then(res => {
          if (res.code === 200) {
            this.originItem = res.data
            this.originItem.putAway = true
            this.originItem.fixGrossProfitRate = null
            this.originItem.fixIssuePrice = null
            this.originItem.storeItems.forEach(p => {
              p.costCopy = null,
                p.costDesc = this.$t('other.a2495') + p.cost
              p.putAway = true
            })
            console.log('originItem', this.originItem)
          } else {
            this.$message.warning(res.msg)
          }
        })
    },










    setPrice(num) {
      console.log(this.priceValue)
      if (num == 1) {
        if (this.priceValue !== '' && this.priceValue !== null) {
          this.tableList.variations.forEach(p => {
            p.price = Number(this.priceValue).toFixed(2)
          })
        }
      } else if (num == 2) {
        let fixGrossProfitRate = Number(this.fixGrossProfitRate)
        console.log('55', this.originItem)
        if (this.fixGrossProfitRate !== '' && this.fixGrossProfitRate !== null) {
          if (fixGrossProfitRate < 5) {
            this.$message.warning(this.$t('other.a2496'))
            return
          }
          this.tableList.variations.forEach(p => {
            p.fixGrossProfitRate = Number(this.fixGrossProfitRate)
            p.price = (p.minRmb - p.minRmb * p.fixGrossProfitRate / 100).toFixed(2)
          })


        }
      } else if (num == 3) {
        console.log('wholesalePrice', this.wholesalePrice)
        if (this.wholesalePrice !== '' && this.wholesalePrice !== null) {
          this.tableList.variations.forEach(p => {
            p.wholesalePrice = Number(this.wholesalePrice).toFixed(2)

          })
          console.log('tableList', this.tableList)


        }
      } else if (num == 4) {

        this.tableList.variations.forEach(p => {
          p.costCopy = this.costValue ? Number(this.costValue).toFixed(2) : null
          p.price = this.costValue ? Number(this.costValue).toFixed(2) : 0
        })

      }

      this.itemKey++
    },

    backTo() {
      this.$router.push({
        path: '/myselfproduct/goods',
        query: {
          groupId: this.$route.query.groupId,
          type: this.$route.query.type
        }
      })
    },

    //更新产品固定毛利率
    updataFixedRate(params) {
      distributionApi
        .putAwayToDistribution(params)
        .then(res => {
          if (res.code === 200) {
            console.log('desc', res.data)
          } else {
            this.$message.warning(res.msg)
          }
        })
    },

    //更新产品模版
    updataModel(params) {
      this.showLoading()
      api
        .updataProduct(params)
        .then(res => {
          if (res.code === 200) {
            console.log('新增模版', res.data)
            this.$message.success(this.$t('other.a2830'))
            this.isEditor = false
          } else {
            this.$message.warning(res.msg)
          }
        })

    },

    //更新产品的供货价
    updataSupplyPrice(item) {
      distributionApi
        .modifyPrice(item)
        .then(res => {
          if (res.code === 200) {
            console.log('desc', res.data)
          } else {
            this.$message.warning(res.msg)
          }
        })
    },

    updataProductInfo() {
      if (this.radio2 == 2) {
        this.originArray.fixGrossProfitRate = this.tableList.variations[0].fixGrossProfitRate
        this.originArray.clearInWarehouse = false
        this.updataFixedRate(this.originArray)
      } else if (this.radio2 == 4) {
        this.originArray.clearInWarehouse = true
        this.originArray.fixGrossProfitRate = this.tableList.variations[0].fixGrossProfitRate
      } else {
        this.originArray.fixGrossProfitRate = null
        this.originArray.clearInWarehouse = false
        this.updataFixedRate(this.originArray)
      }

      this.originArray.storeItems.forEach(p => {
        let ttp = this.tableList.variations.find(item => item.cusCode == p.cusCode)
        p.price = ttp ? ttp.price : null
        p.wholesalePrice = ttp ? ttp.wholesalePrice : null
        p.lowestDistributePrice = ttp ? ttp.lowestDistributePrice : null
        this.updataSupplyPrice(p)
      })
      this.tableList.groupId = this.originArray.groupId

      this.tableList.images.forEach((p, index) => {
        p.positions = index
      })

      let list = this.tableList.tiers[0].images.map(p => { return p })
      this.tableList.tiers[0].imagesUrl = JSON.stringify(list)

      console.log('tableList', this.tableList)
      this.updataModel(this.tableList)
      if (this.radio2 == 4) {
        this.updataGruop()
      }
    },
    //更新供货商产品
    updataGruop() {
      console.log('originArray', this.originArray)
      distributionApi
        .putAwayToDistribution(this.originArray)
        .then(res => {
          if (res.code === 200) {
            console.log('desc', res.data)
            this.$message.success(this.$t('other.a2501'))

          } else {
            this.$message.warning(res.msg)
          }
        })
    },


    publishItem() {
      this.tableList.tiers[0].options = JSON.stringify(this.tableList.variations.map(p => { return p.name }))
      this.tableList.tiers[0].positions = 0
      this.tableList.tiers[0].productId = 0
      this.tableList.userId = this.userId

      this.originItem.storeItems.forEach(p => {
        let ttp = this.tableList.variations.find(item => item.cusCode == p.cusCode)
        p.price = ttp ? Number(ttp.price) : null
        p.wholesalePrice = ttp ? Number(ttp.wholesalePrice) : null
      })

      if (this.tableList.name.length > 120) {
        this.$message.warning(this.$t('other.a2497'))
        return
      }

      let flag = false
      this.tableList.variations.forEach(p => {
        console.log(p.name.length)
        if (p.name.length > 20) {
          flag = true
        }
      })
      if (flag) {
        this.$message.warning(this.$t('other.a2498'))
        return
      }

      console.log('flag', flag)


      console.log('tableList', this.tableList)
      console.log('originItem', this.originItem)
      this.tableList.tiers[0].images = this.tableList.tiers[0].images.filter(p => {
        if (p) {
          return p
        }
      })

      this.tableList.tiers[0].optionArray = this.tableList.variations.map(p => {
        p.variationSku = p.name
        return p.name
      })



      api
        .updataProduct(this.tableList)
        .then(res => {
          if (res.code == 200) {
            api
              .updateProductId({
                groupId: this.$route.query.groupId,
                storeId: this.$route.query.storeId,
                productId: res.data.productId,
                userId: this.userId
              })
              .then(res => {
                if (res.code === 200) {
                  this.$message.success(this.$t('other.a2502'))
                  distributionApi
                    .putAwayToDistribution(this.originItem)
                    .then(res => {
                      if (res.code === 200) {
                        console.log('desc', res.data)
                        this.$message.success(this.$t('other.a2503'))

                      } else {
                        this.$message.warning(res.msg)
                      }
                    })

                } else {
                  this.$message.warning(res.msg)
                }
              })

          } else {
            this.$message.warning(res.msg)
          }
        })
    },
    getData() {

      let variations = JSON.parse(localStorage.getItem('onlineItem')).variations
      console.log('variation', variations)
      let productId = this.$route.query.productId
      let groupId = this.$route.query.groupId
      if (productId) {

        api
          .getStoreItemByGroupId({
            groupId: groupId
          })
          .then(res => {
            if (res.code == 200) {
              this.originArray = res.data
              if (this.originArray.fixGrossProfitRate !== null) {
                this.methodsSupplyPrice = this.originArray.fixGrossProfitRate
                this.radio2 = 2

              }


              api
                .getProductByproductId({
                  productId: productId
                }).then(res => {
                  if (res.code == 200) {
                    console.log('product', res.data)
                    this.tableList = res.data

                    // this.tableList.variations.sort((a,b) => {
                    //   return a.tierIndex[0]-b.tierIndex[0]
                    // })
                    let setIds = []
                    this.tableList.variations.forEach(p => {
                      let ttp = this.originArray.storeItems.find(item => item.cusCode == p.cusCode)
                      setIds.push(ttp.cusCode)
                      let obj = variations.find(item => item.cusCode == p.cusCode)
                      console.log('-------')
                      console.log(obj)
                      p.image = this.tableList.tiers[0].images[p.tierIndex[0]]
                      p.cost = ttp ? ttp.cost : 0
                      p.stock = ttp ? ttp.storeNum : p.stock
                      p.wholesalePrice = ttp ? ttp.wholesalePrice : 0
                      p.fixGrossProfitRate = this.methodsSupplyPrice ? this.methodsSupplyPrice : 0
                      p.country = obj ? obj.country : null
                      p.priceList = obj ? obj.priceList : null
                      p.minRmb = obj ? obj.minRmb : null
                      p.lowestDistributePrice = ttp.lowestDistributePrice
                      p.originPrice = JSON.parse(JSON.stringify(p.price))
                      p.proportion = ttp.proportion == 0.3 ? true : false
                    })
                    let setArr = []
                    this.originArray.storeItems.forEach(v => {
                      if (setIds.indexOf(v.cusCode) == -1) {
                        console.log("====1=====1=======")
                        console.log(v.cusCode)
                        let t = {}

                        t.image = v.image
                        t.cost = v.cost
                        t.stock = v.storeNum
                        t.wholesalePrice = v.wholesalePrice
                        t.fixGrossProfitRate = this.methodsSupplyPrice ? this.methodsSupplyPrice : 0
                        t.country = null
                        t.priceList = null
                        t.minRmb = null
                        t.lowestDistributePrice = v.lowestDistributePrice
                        t.originPrice = JSON.parse(JSON.stringify(v.price))
                        t.proportion = v.proportion == 0.3 ? true : false

                        t.cusCode = v.cusCode
                        t.imageId = v.imageId
                        t.name = null
                        t.price = v.price
                        t.productId = null
                        t.sequence = null
                        t.storeItem = v
                        t.tierId = null
                        t.tierIndex = null
                        t.variationId = null
                        t.variationSku = v.variationName
                        setArr.push(t)
                      }
                    })
                    this.tableList.variations.push(...setArr)

                    console.log('storeItems', this.originArray.storeItems)
                    console.log('variations', this.tableList.variations)


                  }
                })

            }
          })
      }
    },




    getRmb(country, price) {
      return utils.interestRateConversion(country, price)
    },
    Paid(price) {
      let ttp = null
      if (price) {
        ttp = price - price * 0.05
      }
      return ttp ? ttp.toFixed(2) : ttp
    },
  }
}

</script>
<style lang="scss" scoped>
.hasAgentDeatil {
  background-color: #eee;
  box-sizing: border-box;
  padding: 0 0 30px 0;

  .ppomu {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .imgBBox {
      width: 240px;
      height: 240px;
      overflow: hidden;
      border: 1px dashed #eee;

      img {
        width: 100%;
      }
    }
  }

  .ibkg {
    border-bottom: 1px solid #DCDFE6;
    padding-bottom: 5px;
  }


  /deep/ .el-radio__label {
    font-size: 18px;
  }

  /deep/ .el-radio__inner {
    width: 18px;
    height: 18px;
  }


  .avatar-uploader .el-upload {
    border-radius: 6px;
    border: none;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 240px;
    height: 240px;
    line-height: 240px;
    text-align: center;
    border-radius: 5px;
    border: 1px solid #eee;
  }


  .avatar {
    width: 240px;
    height: 240px;
    display: block;
    border: 1px solid #eee;
  }

  .course-container {
    height: 1024px;
    width: 724px;
  }

  .course {
    z-index: 1;
    left: 74px;
    top: 100px;
    position: absolute;
  }

  .code {
    z-index: 2;
    position: absolute;

    width: 150px;
    height: 150px;
  }




  .oknolg {
    display: flex;
  }

  .waterWrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    max-height: 300px;
    overflow-y: scroll;
    background-color: #eee;
  }

  .waterProduct {
    width: 90px;
    height: 90px;
    overflow: hidden;
    margin: 3px;
    cursor: pointer;

    border: 1px solid red;

    img {
      width: 100%;
    }
  }


  .skuWrapper {
    margin-top: 50px;
    padding-top: 10px;
    background-color: #fff;
    box-sizing: border-box;
    margin: 0px 7px 0 7px;
    padding: 16px 10px 25px 10px;
    cursor: pointer;


    .tti {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      margin-right: 50px;
    }


    .addImg {
      display: inline-block;
      width: 50px;
      height: 50px;
      border-radius: 3px;
      border: 1px solid #eee;
      text-align: center;
      line-height: 50px;
      font-size: 18px;
      cursor: pointer;

    }

    .picBox {
      display: inline-block;
      border-radius: 3px;
      border: 1px solid #eee;
    }

    .inputBox {
      width: 80px;
      margin: 0 5px;
    }

    .okng {
      margin-bottom: 20px;
    }

    .ttpoi {
      display: inline-block;
      width: 120px;
      text-align: right;
    }

    .itemDesc {
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 30px;
      display: flex;
      justify-content: flex-start;
      align-items: center;



    }
  }

  .descTitle {
    padding: 10px 0;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    display: flex;






  }

  .okting {
    margin-top: 20px;
  }

  .itemImage {
    background-color: #fff;
    box-sizing: border-box;
    height: 300px;
    margin: 0 7px;
    padding: 16px 10px 25px 10px;
    border-radius: 3px;

    .itemDesc {
      padding-top: 10px;
      display: flex;
      justify-content: space-between;


      .obikg {
        margin-left: 30px;
      }

    }

  }

  .itemWrapper {

    background-color: #fff;
    box-sizing: border-box;

    margin: 30px 7px;
    padding: 16px 10px 25px 10px;
    border-radius: 3px;
    // border: 1px solid #eee;
  }

  .itemDesc {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 30px;
    display: flex;
    color: rgba(0, 0, 0, .65);

    .olnklig {
      display: inline-block;
      width: 120px;
    }
  }

  .iklng {

    text-align: center;


  }

  .kgnlv {
    display: inline-block;
    position: relative;
    overflow: hidden;
    margin: 0 5px;
    cursor: pointer;
    border-radius: 5px;
    border: 1px solid #eee;
    width: 100px;
    height: 100px;

    .deleteImg {
      position: absolute;
      display: inline-block;
      width: 100%;
      text-align: center;
      font-size: 12px;
      padding: 3px 0;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      z-index: 99;
      background-color: rgba(0, 0, 0, .87);
      color: #fff;
    }

    .onkg {
      position: absolute;
      left: 0;
      top: 0;
    }



    .ytjg {
      display: inline-block;
      position: absolute;
      font-size: 12px;
      top: 30%;
      left: 50%;
      transform: translate(-50%, -50%);
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
    }



    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;

    }
  }

  .waterWrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    max-height: 300px;
    overflow-y: scroll;
    background-color: #eee;
  }


  .active {
    box-sizing: border-box;
    border: 3px solid #409EFF;
  }

  .waterProduct {
    width: 90px;
    height: 90px;
    overflow: hidden;
    margin: 3px;
    cursor: pointer;
    position: relative;



    .dexlet {
      position: absolute;
      right: 3px;
      top: 3px;
      width: 10px;
      height: 10px;
      text-align: center;
      line-height: 10px;
      background-color: #fff;
      padding: 5px;
      border-radius: 50px;
      color: #000;
    }

    img {
      width: 100%;
    }
  }

  .uploaImg {
    border: 1px solid #000;
    width: 90px;
    height: 90px;
    margin: 3px;
  }

  /deep/ .el-icon-plus {
    font-size: 25px;
    border: 1px dashed #eee;
  }
}
</style>